function fn_comp_map() {
    var $map = $('#comp_map');
    var $map_inner = $map.find(".map");
    if ($map.length) {
        $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCPMCJKrhprW--MRuRoPGFTJM07R_-RYrk")
            .done(function () {
                //--- GOOGLE MAP --- //
                var coords = $map_inner.data('coords').split(/[\s,]+/);

                var mapOptions = {
                    zoom:7, scrollwheel: false, draggable: false, mapTypeControl: false, disableDefaultUI: false, center: {
                        lat: parseFloat(coords[0]), lng: parseFloat(coords[1])
                    }
                };

                var map = new google.maps.Map($map_inner[0], mapOptions);

                google.maps.event.addListener(map, 'click', function () {
                    map.setOptions({
                        scrollwheel: true, draggable: true
                    });
                });

                var icons = [
                    [50.114715, 14.489214, 1, '/img/marker-1.png','','','https://goo.gl/maps/xEKErkrAbdA2'],
                    [49.4013505, 15.5881254, 1, '/img/marker-2.png','','','https://goo.gl/maps/MVEXSC77wC42']
                ];

                function setMarkers(map, locations) {
                    var infowindow = new google.maps.InfoWindow();
                    for (var i = 0; i < locations.length; i++) {
                        var icon = locations[i];
                        var image = {
                            url: icon[3]
                        };
                        var myLatLng = new google.maps.LatLng(icon[0], icon[1]);
                        var marker = new google.maps.Marker({
                            position: myLatLng,
                            map: map,
                            icon: image,
                            zIndex: icon[2]
                        });
                        function loadURL(marker) {
                            return function () {
                                window.open(marker);
                            }
                        }

                        google.maps.event.addListener(marker, 'click', loadURL(icon[6]));
                    }
                }
                setMarkers(map, icons);
            });
    }
}
